//
//
//
//
//
//
//
//
//

import VMask from './VMask';
import { mapActions } from 'vuex';
import { HIDE_TOAST } from '@/constants/actions';
export default {
  name: 'widget__popup',
  props: {
    cancel: Function
  },
  components: {
    'v-mask': VMask
  }
};